let loginUrl = 'http://localhost:9000/api/v1/auth/login'; 


console.log(`env: ${process.env.NODE_ENV}`);
if(process.env.NODE_ENV === 'production') {
    loginUrl = process.env.REACT_APP_REST_URL + '/api/v1/auth/login';
}

const AuthProvider = {
    // called when the user attempts to log in
    login: ({ username, password }) => {
        console.log(`url: ${loginUrl}`);
        const request = new Request(loginUrl, {
            method: 'POST',
            body: JSON.stringify({ email: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                console.log(response.statusText);
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                console.log(response.json);
                return response.json();
            })
            .then((data) => {
                //TODO Change storage location of token from localStorage to httpOnly Cookie
                localStorage.setItem('token', data.token);
            });
    },
    // called when the user clicks on the logout button
    logout: () => {
        localStorage.removeItem('token');
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: ({ status }) => {
        console.log("AuthProvider.checkError");
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        console.log("AuthProvider.checkAuth");
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => {
        console.log("AuthProvider.getPermissions");
        return Promise.resolve()
    },
};

export default AuthProvider;
